module.exports = __webpack_public_path__ + "static/Kamakshi_Pant.a257ef76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Kamakshi_Pant.jpg
// module id = 241
// module chunks = 25111403944408 251948199435738